<template>
  <section
    class="cta-module-component"
    :class="`cta-module-component-${instance} ${!data.add_background ? 'no-bg' : ''} ${data.orb_position ? 'left' : 'center'}`">
    <div
      class="inner-container top"
      :class="`${data.add_background ? '' : 'pt-16'}`">
      <div
        class="horizontal-line-top"
        :class="`${topLineH} ${data.orb_position ? 'hidden' : 'block'} ${!data.add_background ? 'hidden' : ''}`"
        :style="`background: linear-gradient(90deg, ${data.start_color} 0%, ${data.color} 100%);`"></div>
      <div
        class="vertical-line-top"
        :class="`${topLineV} ${data.orb_position ? 'block lg:hidden' : ''}`"
        :style="`background-color: ${data.color};`"></div>
      <div
        class="orb"
        :class="`${orb} ${data.orb_position ? 'block lg:hidden' : ''}`"
        :style="`background-color: ${data.color}; ${data.color ? `box-shadow: 0 0 20px ${data.color};` : ''}`"></div>
    </div>
    <div class="inner-container modified">
      <div
        class="vertical-line-full"
        :class="`${verticalLineFull} ${data.orb_position ? 'hidden lg:block' : 'hidden'}`"
        :style="`background: linear-gradient(180deg, ${data.start_color} 0%, ${data.color} 100%);`">
        <div
          class="orb"
          :class="orb1"
          :style="`background-color: ${data.color}; box-shadow: 0 0 20px ${data.color};`"></div>
      </div>
      <div
        v-if="data.add_background"
        class="background">
        <div
          v-if="data.background.overlay"
          class="overlay"
          :style="{ backgroundColor: data.background.overlay_color }" />
        <div
          v-if="data.background.colorize"
          class="colorizer"
          :style="{ backgroundColor: data.background.colorize_color }" />
        <div
          v-if="data.background.is_video"
          class="video-bg">
          <video
            autoplay
            playsinline
            muted
            loop>
            <source
              :src="data.background.video.url"
              type="video/mp4" />
          </video>
        </div>
        <div
          v-if="!data.background.is_video"
          class="img-bg">
          <img
            :src="data.background.image.url"
            :alt="data.background.image.alt" />
        </div>
      </div>
      <div class="content">
        <div
          class="container"
          :class="`${data.title_width ? 'wide' : ''} ${data.button.title ? '' : 'no-button'}`">
          <div
            class="title"
            v-html="data.title"></div>
          <div
            class="content"
            v-html="data.description"></div>
          <ButtonGlobal
            v-if="data.button.title"
            :class="data.add_background ? '' : '!py-0'"
            :theme="data.add_background ? '' : 'white-purple'"
            :text="data.button.title"
            :url="data.button.url"
            :target="data.button.target" />
        </div>
      </div>
    </div>
    <div
      class="inner-container bottom"
      :class="`${data.orb_position ? 'hidden' : 'block'} ${!data.add_background ? 'hidden' : ''}`">
      <div
        class="horizontal-line-bottom"
        :class="bottomLineH"
        :style="`background-color: ${data.color};`"></div>
      <div
        class="vertical-line-bottom"
        :class="bottomLineV"
        :style="`background-color: ${data.color};`"></div>
    </div>
  </section>
</template>

<script setup>
/* #META
 {
  "NAME": "CtaComponent",
  "CLASSNAME": "cta-module-component",
  "URL": "http://lifemine.local/templates/"
 }
#ENDMETA */

/*
 *   Insert your logic here
 */
import ButtonGlobal from '@/components/utility/ButtonGlobal.vue'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import useUtils from '@/composables/useUtils'
import { onMounted, onBeforeUnmount } from 'vue'

gsap.registerPlugin(ScrollTrigger)

const props = defineProps(['data'])
const { genUUID, device } = useUtils()

const topLineH = `top-line-h-${genUUID()}`
const topLineV = `top-line-v-${genUUID()}`
const bottomLineH = `bottom-line-h-${genUUID()}`
const bottomLineV = `bottom-line-v-${genUUID()}`
const verticalLineFull = `vertical-line-full-${genUUID()}`
const orb = `orb-${genUUID()}`
const orb1 = `orb-${genUUID()}`
const instance = genUUID()

const lineAnimation = () => {
  if (props.data.add_background) {
    gsap.fromTo(
      `.${topLineH}`,
      { scaleX: 0 },
      {
        scaleX: 1,
        scrollTrigger: {
          trigger: `.cta-module-component-${instance}`,
          id: topLineH,
          start: 'top-=100 center',
          end: 'top+=50 center',
          scrub: true,
          markers: false,
        },
      }
    )

    gsap.fromTo(
      `.${bottomLineH}`,
      { scaleX: 0 },
      {
        scaleX: 1,
        scrollTrigger: {
          trigger: `.cta-module-component-${instance}`,
          id: bottomLineH,
          start: 'top+=600 center',
          end: 'bottom-=50 center',
          scrub: true,
          markers: false,
        },
      }
    )

    gsap.fromTo(
      `.${bottomLineV}`,
      { scaleY: 0 },
      {
        scaleY: 1,
        scrollTrigger: {
          trigger: `.cta-module-component-${instance}`,
          id: bottomLineV,
          start: 'top+=500 center',
          end: 'top+=600 center',
          scrub: true,
          markers: false,
        },
      }
    )

    gsap.fromTo(
      `.${orb}`,
      { y: 0 },
      {
        scale: 1,
        opacity: 1,
        y: device.value === 'desktop' ? 120 : 90,
        scrollTrigger: {
          trigger: `.cta-module-component-${instance}`,
          id: orb,
          start: 'top+=200 center',
          end: 'top+=500 center',
          scrub: true,
          markers: false,
        },
      }
    )
    gsap.fromTo(
      `.${orb1}`,
      { y: 0 },
      {
        y:
          gsap.getProperty(
            '.cta-module-component .vertical-line-full',
            'height'
          ) - 60,
        scrollTrigger: {
          trigger: `.cta-module-component-${instance}`,
          id: orb1,
          start: 'top center',
          end: 'bottom center',
          scrub: true,
          markers: false,
        },
      }
    )

    gsap.fromTo(
      `.${orb1}`,
      { scale: 0, opacity: 0 },
      {
        scale: 1,
        opacity: 1,
        scrollTrigger: {
          trigger: `.cta-module-component-${instance}`,
          id: `so-${orb1}`,
          start: 'top center',
          end: 'top+=100 center',
          scrub: true,
          markers: false,
        },
      }
    )

    gsap.fromTo(
      `.${orb1}`,
      { scale: 1, opacity: 1 },
      {
        scale: 0,
        opacity: 0,
        scrollTrigger: {
          trigger: `.cta-module-component-${instance}`,
          id: `so-out-${orb1}`,
          start: 'center+=50 center',
          end: 'center+=320 center',
          scrub: true,
          markers: false,
        },
      }
    )
    gsap.set(`.${orb1}`, { scale: 0, opacity: 0 })
  } else {
    gsap.fromTo(
      `.${orb}`,
      { y: 0 },
      {
        scale: 1,
        opacity: 1,
        y: 60,
        scrollTrigger: {
          trigger: `.cta-module-component-${instance}`,
          id: orb,
          start: 'top+=200 center',
          end: 'top+=400 center',
          scrub: true,
          markers: false,
        },
      }
    )
  }

  gsap.fromTo(
    `.${topLineV}`,
    { scaleY: 0 },
    {
      scaleY: 1,
      scrollTrigger: {
        trigger: `.cta-module-component-${instance}`,
        id: topLineV,
        start: 'top+=50 center',
        end: 'top+=200 center',
        scrub: true,
        markers: false,
      },
    }
  )

  gsap.fromTo(
    `.${orb}`,
    { scale: 0, opacity: 0 },
    {
      scale: 1,
      opacity: 1,
      scrollTrigger: {
        trigger: `.cta-module-component-${instance}`,
        id: `so-${orb}`,
        start: 'top+=100 center',
        end: 'top+=200 center',
        scrub: true,
        markers: false,
      },
    }
  )
}

onMounted(() => {
  lineAnimation()
})

onBeforeUnmount(() => {
  ScrollTrigger.getById(topLineH)?.kill()
  ScrollTrigger.getById(topLineV)?.kill()
  ScrollTrigger.getById(bottomLineH)?.kill()
  ScrollTrigger.getById(bottomLineV)?.kill()
  ScrollTrigger.getById(orb)?.kill()
  ScrollTrigger.getById(orb1)?.kill()
  ScrollTrigger.getById(`so-${orb}`)?.kill()
  ScrollTrigger.getById(`vertical-line-full-${genUUID()}`)?.kill()
  ScrollTrigger.getById(`so-${orb1}`)?.kill()
  ScrollTrigger.getById(`so-out-${orb1}`)?.kill()
})
</script>

<style lang="scss">
.cta-module-component {
  @apply h-fit;
  &.left {
    @apply my-20 mt-0 lg:mt-20;
    .inner-container.top {
      @apply pb-0;
    }
    .inner-container.modified {
      @apply pt-28 lg:pt-40;
    }
  }
  &.center {
    @apply my-0;
  }
  &.no-bg {
    @apply min-h-[300px] h-fit pb-10;
    .inner-container.top {
      .vertical-line-top {
        @apply h-20;
      }
    }
    .inner-container.modified {
      @apply h-fit py-0 lg:py-12;
      .content {
        .container {
          @apply pb-16 pt-0;
          &.no-button {
            @apply pb-0;
          }
          .title {
            @apply mb-0;
            h3 {
              @apply mb-6 lg:mb-10 pt-10 lg:pt-0 text-lm_purple heading-3;
              strong {
                @apply text-lm_yellow font-normal;
              }
              sup {
                @apply text-[35%] top-[-1.4em] text-lm_yellow;
              }
            }
            h4 {
              @apply mb-6 lg:mb-10 pt-10 lg:pt-0 text-lm_purple heading-4;
              strong {
                @apply text-lm_yellow font-normal;
              }
              sup {
                @apply text-[35%] top-[-1.4em] text-lm_yellow;
              }
            }
          }
          .content {
            * {
              @apply text-black;
            }
          }
        }
      }
    }
  }
  .inner-container.top {
    @apply relative pb-10;
    .horizontal-line-top {
      @apply h-[1px] w-6/12 origin-left;
    }
    .vertical-line-top {
      @apply absolute h-24 lg:h-36 w-[1px] left-1/2 top-0 z-10 origin-top;
    }
    .orb {
      @apply absolute w-6 lg:w-8 h-6 lg:h-8 rounded-full left-[calc(50%-12px)] lg:left-[calc(50%-16px)] blur-[2px] top-2;
    }
  }
  .inner-container.modified {
    @apply max-w-[1450px] z-1 py-20 lg:py-40;
    .vertical-line-full {
      @apply absolute left-[30px] md:left-[60px] xl:left-[100px] origin-top h-[calc(100%+100px)] lg:h-[calc(100%+160px)] w-[1px] z-20;
      top: 50%;
      transform: translateY(-50%);
      .orb {
        @apply absolute w-6 lg:w-8 h-6 lg:h-8 rounded-full left-[calc(50%-12px)] lg:left-[calc(50%-16px)] blur-[2px] top-2 opacity-0;
      }
    }
    .content {
      @apply w-full h-full flex items-center justify-center z-10 relative;
      .container {
        @apply flex flex-col justify-center items-center text-center px-8 lg:px-0 max-w-[930px];
        &.wide {
          @apply max-w-[1060px];
        }
        .title {
          @apply mb-4;
          h3 {
            @apply mb-6 lg:mb-10 pt-10 lg:pt-0 text-white heading-3;
            strong {
              @apply text-lm_yellow font-normal;
            }
            sup {
              @apply text-[35%] top-[-1.4em] text-lm_yellow;
            }
          }
          h4 {
            @apply mb-6 lg:mb-10 pt-10 lg:pt-0 text-white heading-4;
            strong {
              @apply text-lm_yellow font-normal;
            }
            sup {
              @apply text-[35%] top-[-1.4em] text-lm_yellow;
            }
          }
        }
        .content {
          * {
            @apply text-white mb-6 lg:mb-10 medium;
          }
        }
      }
    }
    .background {
      @apply absolute inset-0 mx-[10px] lg:mx-0;
      .overlay {
        @apply absolute inset-0 z-9;
      }
      .colorizer {
        @apply absolute inset-0 mix-blend-color z-10;
      }
      .video-bg {
        @apply absolute inset-0;
        video {
          @apply w-full h-full object-cover;
        }
      }
      .img-bg {
        @apply absolute inset-0;
        img {
          @apply w-full h-full object-cover;
        }
      }
    }
  }
  .inner-container.bottom {
    @apply relative pt-10;
    .horizontal-line-bottom {
      @apply h-[1px] w-6/12 left-1/2 relative origin-left;
    }
    .vertical-line-bottom {
      @apply absolute h-full w-[1px] left-1/2 bottom-0 z-10 origin-top;
    }
  }
}
</style>
